import { useEffect, useState } from 'react';
import { getFileBlob } from '../api/generateVideo.api';

/**
 * Object URL for an authenticated file path. `<video src>` cannot send the Bearer token, so
 * the file is fetched with it and played from a blob URL (revoked on change/unmount).
 */
export function useAuthenticatedObjectUrl(path: string | null) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!path) return undefined;
    let objectUrl: string | null = null;
    let cancelled = false;
    setFailed(false);

    getFileBlob(path)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      setUrl(null);
    };
  }, [path]);

  return { url, failed, loading: Boolean(path) && !url && !failed };
}
